import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CompletedUmbrellaProjects from "./AllCancelledOrder/CancelledUmbrellaProjects";
import CompletedProjects from "./AllCancelledOrder/CancelledProjects";
import CompletedContests from "./AllCancelledOrder/CancelledContests";
import CompletedJobs from "./AllCancelledOrder/CancelledJobs";
import CompletedAuctionBids from "./AllCancelledOrder/CancelledAuctionBids";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import CompletedBuyProduct from "./AllCancelledOrder/CancelledBuyProduct";
import CompletedRentalProduct from "./AllCancelledOrder/CancelledRentalProduct";
import MineCompletedBXPListing from "./AllCancelledOrder/MineCancelledBXPListing";
import MineCancelBXPListing from "../CompletedOrder/AllCompletedOrders/MineCancelBXPListing";


export default function CancelledOrder({ postcounts }) {
  const { urlstate, setMyorderCompletedroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("CompletedOrderUmbrellaprojects");

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (urlstate?.myorderCompletedroute) {
      setActiveTab(
        urlstate?.myorderCompletedroute || "CompletedOrderUmbrellaprojects",
      );
    } else {
      setActiveTab("CompletedOrderUmbrellaprojects");
    }
  }, [urlstate, urlstate?.myorderCompletedroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderCompletedroute(tab);
  };

  return (
    <div className="order-tabs">
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "CompletedOrderUmbrellaprojects" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedOrderUmbrellaprojects")}
          >
            Umbrella projects ({postcounts?.umbrella_project || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "CompletedOrderProjects" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedOrderProjects")}
          >
            Post & Browse Projects (PBP) ({postcounts?.project || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "CompletedOrderContests" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedOrderContests")}
          >
            Win business Opportunities (WBO) ({postcounts?.contest || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "CompletedOrderJobs" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedOrderJobs")}
          >
            Part time Job (PTJ) ({postcounts?.job || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab == "MineCompletedBXPListing" ? "active" : ""}`}
            onClick={() => handleTabClick("MineCompletedBXPListing")}
          >
            One Time Services (OTS)  ({postcounts?.bxp || 0})
          </a>
        </li>
        {/* <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "CompletedOrderAuctionbids" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedOrderAuctionbids")}
          >
            Buy & Sell with Auction (BSA) bids ({postcounts?.auction || 0})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "CompletedBuyProduct" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedBuyProduct")}
          >
            Buy & Sell with Market (BSM) ({postcounts?.sale || 0})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "CompletedRentalProduct" ? "active" : ""}`}
            onClick={() => handleTabClick("CompletedRentalProduct")}
          >
            Turn Assets to Income (TAI) ({postcounts?.rental || 0})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "MineCompletedBXPListing" ? "active" : ""}`}
            onClick={() => handleTabClick("MineCompletedBXPListing")}
          >
            One Time Services (OTS)  ({postcounts?.bxp || 0})
          </a>
        </li> */}
      </ul>
      <div className="tab-content">
        {activeTab == "CompletedOrderUmbrellaprojects" && (<CompletedUmbrellaProjects />)}
        {activeTab == "CompletedOrderProjects" && <CompletedProjects />}
        {activeTab == "CompletedOrderContests" && <CompletedContests />}
        {activeTab == "CompletedOrderJobs" && <CompletedJobs />}
        {activeTab == "MineCompletedBXPListing" && (<MineCancelBXPListing />)}
        {/* {activeTab == "CompletedOrderAuctionbids" && <CompletedAuctionBids />}
        {activeTab == "CompletedBuyProduct" && (<CompletedBuyProduct />)}
        {activeTab == "CompletedRentalProduct" && (<CompletedRentalProduct />)}
        {activeTab == "MineCompletedBXPListing" && (<MineCompletedBXPListing />)} */}
      </div>
    </div>
  );
}
